export const mesuringUnits = {
  LARGE_SPOON: "Large Spoon",
  SMALL_SPOON: "Small Spoon",
  MEDIUM_SPOON: "Med. Spoon",
  DEFAULT_UNIT_ARRAY: ["tbsp", "tsp"],
  TBSP: "tbsp",
  TSP: "tsp",
};

export const getIngredientValue = (val: number) => {
    if (val % 3 === 0 && val >= 6) {
        return val / 6
    }
    else if (val <= 3.5 && val !== 2) {
        return val
    }
    return val / 2
}

export const getIngredientUnit = (val: number) => {
    if (val % 3 === 0 && val >= 6) {
        return mesuringUnits.LARGE_SPOON
    }
    else if (val <= 3.5 && val !== 2) {
        return mesuringUnits.SMALL_SPOON
    }
    return mesuringUnits.MEDIUM_SPOON
}

export const copyToClipboard = async (rawData: any, contentType: string) => {
    const blob = new Blob([rawData], { type: contentType });
    const data = [new window.ClipboardItem({ [contentType]: blob })];
    try {
        return navigator.clipboard.write(data);
    } catch(err) {
        throw err;
    }
}